<template>
  <div class="policy policy-view" v-html="policy" />
</template>
<style>
.policy * {
  all: revert;
}
.policy-view {
  padding: 12px 15px;
}
</style>
<script>
import AdminService from '@/services/AdminService';

export default {
  name: 'Policy',
  mounted() {
    this.loadPolicy();
  },
  data() {
    return {
      policy: null,
    }
  },
  methods: {
    async loadPolicy() {
      const { policy } = await AdminService.PoliciesAndTemplates.read();
      this.policy = policy ?? null;
    }
  }
}
</script>